import { CSSResultGroup, TemplateResult, html } from 'lit';
import {
  LightDomStyles,
  OutlineElement,
  SlotsController,
} from '@phase2/outline-core';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './outline-profile-card.css.lit';
import placeholderImage from '../../assets/images/placeholder-image.png';

type variants = 'small' | 'large';

/**
 * The OutlineProfileCard component
 * @element outline-profile-card
 */
@customElement('outline-profile-card')
export class OutlineProfileCard extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  lightDomStyles = new LightDomStyles(
    this,
    componentStyles,
    this.tagName.toLowerCase()
  );

  /**
   * Determines the variant of the profile card
   */
  @property({ type: String, reflect: true, attribute: 'variation' })
  variation: variants = 'large';

  slots = new SlotsController(this);

  render(): TemplateResult {
    return this.variation === 'large'
      ? html`
          <article class="container">
            ${this.slots.exist('image')
              ? html`${this.slots.conditionalSlot('image', false)}`
              : html`
                  <div class="image">
                    <img src="${placeholderImage}" alt="" />
                  </div>
                `}
            <div class="content">
              ${this.slots.conditionalSlot('name', false)}
              <hr class="rule" />
              <div class="employment-info">
                ${this.slots.conditionalSlot('title', false)}
                ${this.slots.conditionalSlot('department', false)}
              </div>
              <div class="contact-info">
                ${this.slots.conditionalSlot('phone', false)}
                ${this.slots.conditionalSlot('email', false)}
              </div>
              ${this.slots.conditionalSlot('cta', false)}
            </div>
          </article>
        `
      : html`
          <article class="small container">
            ${this.slots.exist('image')
              ? html`${this.slots.conditionalSlot('image', false)}`
              : html`
                  <div class="image">
                    <img src="${placeholderImage}" alt="" />
                  </div>
                `}
            <div class="content small">
              ${this.slots.conditionalSlot('name', false)}
              <hr class="rule" />
              ${this.slots.conditionalSlot('title', false)}
            </div>
          </article>
        `;
  }
}
